import { EXCHANGES } from "@shared/common/constants.ts";
import { ConsolidatedCoinData, PositionData } from "@shared/types";

type PositionItem = PositionData | ConsolidatedCoinData;

const exchangeOf = (position: PositionItem) =>
  "exchange" in position ? position.exchange : position.exchanges?.[0];

/**
 * The margin a position's unrealized PnL is denominated in, as in the classic
 * positions table: the margin coin amount, except on Bitget Inverse where the
 * PnL is reported against the USD margin.
 */
export const getPositionPnlBase = (position: PositionItem) =>
  exchangeOf(position) === EXCHANGES.BITGET_INVERSE
    ? position.margin?.[2]
    : position.margin?.[0];

/**
 * A position's margin and unrealized PnL in the display currency, and its ROI.
 * The PnL is converted with the rate of the margin it is denominated in.
 */
export const getPositionFigures = (position: PositionItem, isBtc: boolean) => {
  const margin = position.margin;
  const base = getPositionPnlBase(position);
  const rate = margin && base ? margin[isBtc ? 1 : 2] / base : undefined;
  return {
    margin: margin ? margin[isBtc ? 1 : 2] || 0 : 0,
    pnl:
      rate !== undefined && position.unrealized_pnl
        ? position.unrealized_pnl * rate
        : 0,
    roi:
      base && position.unrealized_pnl !== undefined
        ? (position.unrealized_pnl / base) * 100
        : undefined,
  };
};
